import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f40da98")

_pushScopeId("data-v-0f40da98")
const _hoisted_1 = { class: "nav-container flexbox-row justify-space-between padding-bottom-20 padding-top-20" }
const _hoisted_2 = { class: "title color-white barlow" }
const _hoisted_3 = { class: "table-bg" }
const _hoisted_4 = { class: "p-d-flex p-ai-end gap-12" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
_popScopeId()

import { client } from "@/api/client-v2";
import { MembershipFilters } from "@/api/types";
import EditMembershipModal from "@/components/membership/EditMembershipModal.vue";
import FilterMemberships from "@/components/membership/FilterMemberships.vue";
import { formatDateDDMMYYYY } from "@/services/dates.service";
import { showToast } from "@/services/error-management.service";
import NewMembershipModal from "@/components/new-membership-modal/NewMembershipModal.vue";
import { useStore } from "@/store/store";
import Column from "primevue/column";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

type SortField = 'activationDate' | 'userCognome' | 'expirationDate' | 'price';

export default _defineComponent({
  setup(__props) {

const LIMIT = 15;

const { t } = useI18n();
const store = useStore();

const page = ref(1);
const total = ref(0);
const loading = ref(false);
const items = ref([]);
const first = computed(() => (page.value - 1) * LIMIT);
const sortBy = ref<SortField>('activationDate');
const sortDirection = ref<1 | -1>(-1);

const filters = ref<MembershipFilters>({
  activationDateFrom: undefined,
  activationDateTo: undefined,
  expirationDateFrom: undefined,
  expirationDateTo: undefined,
  descriptionLike: undefined,
  status: undefined
})



const myClubId = computed(function (): string {
  return store.getters.getMyClub.club_id;
});

const getMemberships = async () => {
  try {
    loading.value = true;
    const { data } = await client.getMemberships({
      clubId: myClubId.value,
      page: page.value,
      limit: LIMIT,
      sortBy: sortBy.value,
      sortDirection: sortDirection.value < 1 ? 'DESC' : 'ASC',
      filters: { ...filters.value },
    });
    items.value = data.data;
    total.value = data.totalCount;
  } catch (error) {
    console.error('Error fetching users:', error);
    items.value = [];
    total.value = 0;
    page.value = 1;
    showToast();
  } finally {
    loading.value = false;
  }
}

const pageEvent = (event: { page: number }) => {
  page.value = event.page + 1;
  getMemberships()
}

const softRefresh = () => {
  loading.value = true;
  items.value = [];
  total.value = 0;
  getMemberships()
}

const paymentStatusLabel = (status?: string) => {
  if (!status) return '-'
  const statusLabels = {
    'ELABORATED': 'Elaborato',
    'FAILED': 'Fallito',
    'SCHEDULED': 'Programmato',
    'CANCELLED': 'Cancellato',
    'COMPLETED': 'Completato'
  };
  return statusLabels[status] || status;
}

const searchFromFirstPage = () => {
  page.value = 1;
  getMemberships();
}

const sortEvent = (event: { sortField: SortField; sortOrder: -1 | 1 }) => {
  sortDirection.value = event.sortOrder;
  sortBy.value = event.sortField;
  searchFromFirstPage();
}

onMounted(() => {
  getMemberships()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_unref(t)('membership')), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_DataTable, {
        value: items.value,
        lazy: "",
        paginator: "",
        rows: 15,
        "page-link-size": 10,
        first: _unref(first),
        "total-records": total.value,
        loading: loading.value,
        "responsive-layout": "fixed",
        onPage: pageEvent,
        onSort: sortEvent,
        size: "large",
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
        currentPageReportTemplate: "{first} a {last} di {totalRecords} memberships",
        "sort-field": sortBy.value,
        "sort-order": sortDirection.value,
        paginatorPosition: "top"
      }, {
        empty: _withId(() => [
          _createVNode("p", null, _toDisplayString(_unref(t)('no_records')), 1)
        ]),
        paginatorLeft: _withId(() => [
          _createVNode("div", _hoisted_4, [
            _createVNode(FilterMemberships, {
              filters: filters.value,
              "onUpdate:filters": [
                _cache[1] || (_cache[1] = ($event: any) => (filters.value = $event)),
                searchFromFirstPage
              ]
            }, null, 8, ["filters"]),
            _createVNode(NewMembershipModal, { onUpdated: searchFromFirstPage })
          ])
        ]),
        default: _withId(() => [
          _createVNode(_unref(Column), {
            field: "userCognome",
            header: _unref(t)('user'),
            sortable: ""
          }, {
            body: _withId((slotProps) => [
              _createVNode(_component_router_link, {
                to: { name: 'user-details', params: { id: slotProps.data.userId } },
                class: "color-blue p-text-bold underline"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(slotProps.data.userNome) + " " + _toDisplayString(slotProps.data.userCognome), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "activationDate",
            header: _unref(t)('activation_date'),
            sortable: ""
          }, {
            body: _withId((slotProps) => [
              _createTextVNode(_toDisplayString(_unref(formatDateDDMMYYYY)(slotProps.data.activationDate)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "expirationDate",
            header: _unref(t)('expiration_date'),
            sortable: ""
          }, {
            body: _withId((slotProps) => [
              _createTextVNode(_toDisplayString(_unref(formatDateDDMMYYYY)(slotProps.data.expirationDate)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "expirationDate",
            header: _unref(t)('description')
          }, {
            body: _withId((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.description), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "price",
            header: _unref(t)('price'),
            sortable: ""
          }, {
            body: _withId((slotProps) => [
              _createTextVNode(_toDisplayString((slotProps.data.price / 100).toFixed(2)) + " € ", 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "status",
            header: _unref(t)('status')
          }, {
            body: _withId((slotProps) => [
              _createTextVNode(_toDisplayString(_unref(t)(slotProps.data.status)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "paymentMethod",
            header: _unref(t)('purchase_channel')
          }, {
            body: _withId((slotProps) => [
              (slotProps.data.paymentMethod === 'CASH')
                ? (_openBlock(), _createBlock("span", _hoisted_5, "Al centro"))
                : (slotProps.data.paymentMethod === 'CARD')
                  ? (_openBlock(), _createBlock("span", _hoisted_6, "Online"))
                  : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(slotProps.data.paymentMethod || '-'), 1))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "statusPayment",
            header: _unref(t)('payment_status')
          }, {
            body: _withId((slotProps) => [
              _createVNode("span", {
                class: { 'color-red': slotProps.data.statusPayment === 'FAILED' }
              }, _toDisplayString(paymentStatusLabel(slotProps.data.statusPayment)), 3)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "welcomeKitDelivered",
            header: _unref(t)('kit_delivery')
          }, {
            body: _withId((slotProps) => [
              _createVNode("i", {
                class: slotProps.data.welcomeKitDelivered ? 'pi pi-check' : 'pi pi-times'
              }, null, 2)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "autoRenewal",
            header: _unref(t)('auto_renewal')
          }, {
            body: _withId((slotProps) => [
              _createVNode("i", {
                class: slotProps.data.autoRenewal ? 'pi pi-check' : 'pi pi-times'
              }, null, 2)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "editMembership",
            class: "short-column"
          }, {
            body: _withId((slotProps) => [
              _createVNode(EditMembershipModal, {
                membership: slotProps.data,
                onUpdating: _cache[2] || (_cache[2] = () => loading.value = true),
                onUpdated: softRefresh
              }, null, 8, ["membership"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "first", "total-records", "loading", "sort-field", "sort-order"])
    ])
  ], 64))
}
}

})